// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"23afd481","513":"6fa8d3a1","703":"a8f6b726"}[chunkId] + ".chunk.js";
};